<template>
    <div>
        <b-row v-if="!loading && userInfoLoaded">
            <b-col md="4">
                <information></information>
            </b-col>
            <b-col md="8">

                <smartvault-files></smartvault-files>

                <issue-photos></issue-photos>

                <variants 
                    v-if="!variantId"
                    :variants="product.variants">
                </variants>

                <serial-numbers
                    :variants="product.variants"
                    :variant="variant"
                    :serial-numbers="serialNumbers"
                ></serial-numbers>

                <product-story></product-story>

                <smartvault-analytics></smartvault-analytics>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Information from "./Product/Information";
import SmartvaultFiles from "./Product/Files";
import Variants from "./Product/Variants";
import SerialNumbers from "./Product/SerialNumbers";
import ProductStory from "./Product/ProductStory";
import SmartvaultAnalytics from "./Product/Analytics";
import IssuePhotos from "./Product/IssuePhotos";

export default {
  components: {
    IssuePhotos,
    SmartvaultAnalytics,
    SerialNumbers,
    Variants,
    ProductStory,
    SmartvaultFiles,
    Information
  },
  props: {
    productId: { type: Number, required: true },
    routeVariantId: Number,
    productStories: { type: Array },
    serialNumbers: { type: Array }
  },
  data() {
    return {
      positionTop: 0,
      type: "product",
      variants: [],
      product_stories: [],
      userInfoLoaded: false
    };
  },
  methods: {
    ...mapActions("smartVaultProduct", ["getProduct"]),
    ...mapActions("me", ["getMe"])
  },
  computed: {
    ...mapState("smartVaultProduct", {
      variantId: state => state.variantId,
      product: state => state.product,
      loading: state => state.loading
    }),
    ...mapGetters("smartVaultProduct", {
      variant: "getVariant"
    })
  },
  mounted() {
    this.getMe().then(() => {
      this.userInfoLoaded = true;
    });

    this.getProduct(this.productId);

    if (this.routeVariantId) {
      const numericId = parseInt(this.routeVariantId, 10);
      this.$store.commit("smartVaultProduct/setVariant", numericId);
    }
  }
};
</script>

<style scoped>
.defaultPreview {
  display: none;
}

.hidePreview {
  position: fixed;
  width: 380px;

  animation-name: hidePreview;
  -webkit-animation-name: hidePreview;

  animation-duration: 700ms;
  -webkit-animation-duration: 700ms;

  animation-timing-function: ease-in-out;
  -webkit-animation-timing-function: ease-in-out;

  visibility: hidden !important;
}

@keyframes hidePreview {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

.showPreview {
  display: block;
  position: fixed;
  width: 380px;
  right: 0;
  border-left: 4px solid #000066;
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: calc(100vh - 53px);
  top: 53px;
  background-color: white;
  z-index: 9;

  text-align: center;

  animation-name: showPreview;
  -webkit-animation-name: showPreview;

  animation-duration: 700ms;
  -webkit-animation-duration: 700ms;

  animation-timing-function: ease-in-out;
  -webkit-animation-timing-function: ease-in-out;

  visibility: visible !important;
}

@keyframes showPreview {
  0% {
    transform: translateX(150%);
  }
  100% {
    transform: translateX(0%);
  }
}

.buttonOpen {
  display: block;
  margin-top: 15px;
  right: 380px;
  width: fit-content;
  position: fixed;
  z-index: 9;
  background-color: white;
  border-right: 0;
  border-radius: 10px 0 0 10px;
  animation-name: buttonOpen;

  animation-duration: 700ms;
  -webkit-animation-duration: 700ms;

  animation-timing-function: ease-in-out;
  -webkit-animation-timing-function: ease-in-out;

  visibility: visible !important;
}

@keyframes buttonOpen {
  0% {
    transform: translateX(200%);
  }
  100% {
    transform: translateX(0%);
  }
}

.buttonClose {
  display: block;
  margin-top: 15px;
  width: fit-content;
  position: fixed;
  z-index: 9;
  background-color: white;
  border-right: 0;
  border-radius: 10px 0 0 10px;
  right: 0;
}
</style>
